export const TokenTypes = {
  INVITE_MFA_USER: 'INVITE_MFA_USER',
  MFA_REGISTRATION: 'MFA_REGISTRATION',
};
